/**
 * Created by guga on 8/29/2016.
 */
import { Injectable } from '@angular/core';
import { Response }   from '@angular/http';

import { IRequestErrorHandler, IXhrErrorHandler } from '../sas-models/error-handler';
import { IRequestPayload }                        from '../sas-models/request-payload';
import { IXhrRequestPayload, IXhrResponse }       from '../sas-models/xhr-types';
import { ErrorHandlerSas }                        from './error-handler.sas';

@Injectable()
export class ErrorHandlerBuilderSas {
    public constructor(private _errorHandler : ErrorHandlerSas) {}

    public buildRequestErrorHandler(errorHandler : IRequestErrorHandler, requestPayload : IRequestPayload) {
        return (error : Response) => {
            if (!errorHandler)
                return this._errorHandler.requestErrorHandler(error, requestPayload);
            return errorHandler(error, requestPayload);
        };
    }

    public buildXhrErrorHandler(errorHandler : IXhrErrorHandler, xhrPayload : IXhrRequestPayload) {
        return (error : IXhrResponse) => {
            if (!errorHandler)
                return this._errorHandler.xhrErrorHandler(error, xhrPayload);
            return errorHandler(error, xhrPayload);
        };
    }
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas/error-handler-builder.sas.ts